import { useTranslation } from "react-i18next"
import { Container, Row, Col } from 'react-bootstrap'
import { Link, useParams } from 'react-router-dom'

export const EmailSend = () => {
    const { t } = useTranslation()
    const { email } = useParams();

    return (
        <Container>
            <Row className="text-center my-3">
                <Link className="btn my-3 px-5" to="/login">
                    <img src="../images/arrow-back.svg" alt="arrow-back" width={25}></img>
                </Link>
            </Row>
            <Row className='m-5 p-3'>
                <Col className="justify-content-center text-center p-4">
                    <Row className='py-3'>
                        <Col className='text-center'>
                            <h4>{t('forgot.emailsend1')}</h4>
                        </Col>
                    </Row>
                    <Row className='py-3'>
                        <Col className='text-center'>
                            <h4><strong>{email}</strong></h4>
                        </Col>
                    </Row>
                    <Row className='py-3'>
                        <Col className='text-center'>
                            <h4 className='colorgrisoscuro fs-13'>{t('forgot.emailsend2')}</h4>
                        </Col>
                    </Row>
                    <Row className='py-3'>
                        <Col className='text-center'>
                            <h4><u><Link to="/forgotpassword" className="sd-forgot">{t('forgot.emailsend3')}</Link></u></h4>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )    
}
